import React from 'react';
import {FormattedMessage} from "react-intl";

import {red50, red500} from "assets/jss/main";

function EnvironmentWarning(props) {
    if (!['preprod', 'sandbox'].includes(process.env.REACT_APP_ENVIRONMENT)) {
        return null;
    }

    return (
        <div style={{
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: "bold",
            backgroundColor: red50,
            color: red500,
        }}>
            <FormattedMessage id={`sidebar.app.process.${process.env.REACT_APP_ENVIRONMENT}`} />
        </div>
    );
}

export default EnvironmentWarning;
